var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.slide.templateType,{tag:"component",attrs:{"slide":_vm.slide,"sublessonId":_vm.sublessonId}})
}
var staticRenderFns = []

export { render, staticRenderFns }